import { render, staticRenderFns } from "./ypcxListActionII.vue?vue&type=template&id=5cfe3125&scoped=true"
import script from "./ypcxListActionII.vue?vue&type=script&lang=js"
export * from "./ypcxListActionII.vue?vue&type=script&lang=js"
import style0 from "./ypcxListActionII.vue?vue&type=style&index=0&id=5cfe3125&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfe3125",
  null
  
)

export default component.exports